import { Injectable, inject, signal } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AccountService } from './account';
import { HistoryEventService } from './history.event.service';
import * as VKID from '@vkid/sdk';
import { AuthSourceVK } from '../const/AuthConst';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})

export class AuthVkService {
  private accountService = inject(AccountService);

  constructor(
    private historyEventService: HistoryEventService,
    private router: Router
  ) {
    this.initConfiguration();
  }

  initConfiguration() {

    var verifier = this.generateRandomString(45);
    this.accountService.setVerifier(verifier);

    VKID.Config.init({
      app: environment.vkAppId,
      redirectUrl: environment.vkAuthReturnUrl,
      state: 'state',
      scope: 'phone email',
      codeVerifier: verifier,
      responseMode: VKID.ConfigResponseMode.Callback
    });
  }

  generateRandomString(len: number) {
    let possible = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    var res = "";
    var n: number;
    for (var i = 0; i < len; i++) {
      res += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return res;
  }

  login() {
    var token = this.accountService.getAccessToken();
    if (!this.accountService.isAuthSourceVK() || token.length == 0) {
      VKID.Auth.login()
        .then((res: any) => {
          this.accountService.getAccountTokenVK(res.code, res.device_id)
            .subscribe(
              {
                next: (data) => {
                  if (data.accountId != '-1') {
                    this.accountService.checkProfileAndSetInfo(data, AuthSourceVK);
                  }
                  else {
                    this.router.navigate(['noaccount']);
                  }
                },
                error: (e) => {
                  this.accountService.authSendError('', JSON.stringify(e), 'VkAuth');
                  this.router.navigate(['']);
                }
              }
            )
        })
        .catch((error) => {
          this.accountService.authSendError('', JSON.stringify(error), 'VkAuth');
        })
    }
    else {
      this.historyEventService.setEvent('account');
      this.router.navigate(["/main"]);
    }
  }

  logout() {
  }
}
